import "./templatetwo.css";
import "../style.css";
import {
  React,
  ArrowBackIosNewIcon,
  ReactPlayer,
  useLocation,
  useNavigate,
  Marquee,
} from "../../../Libraries/Post/LayoutPreview/index";

const TemplateTwo = () => {
  const location = useLocation();
  const navigate = useNavigate();
  console.log(navigate);

  console.log("temp two = ", location.state);
  console.log(location.state.currentScreen[0].value);

  const handleNavigate = () => {
    if (location.state.from === "editpost") {
      console.log("testing edit");
      navigate("/editPost", { state: location.state, replace: true });
    } else if (location.state.from === "addnewpost") {
      navigate("/addnewpost", { state: location.state, replace: true });
    } else {
        if(location.state.media.ser_collection_id){
          console.log("Testing");
          navigate("/groupposts", {
            state: location.state.currentScreen,
            replace: true,
          });
        }else{
          navigate("/posts", {
            state: location.state.currentScreen,
            replace: true,
          });
        }
      }
    
  };
  return (
    <div className="container d-flex justify-content-center align-items-center">
      <div className="tele">
        <div className="screen">
          <div className="l2page">
            <ArrowBackIosNewIcon
              id="button"
              fontSize="30px"
              style={{
                position: "absolute",
                zIndex: 10,
                fontSize: "2em",
                color: "red",
              }}
              onClick={handleNavigate}
            />
            {/* {location.state?.finalfile.type === "Image" ? ( */}
            {location.state?.media.finalfile.txt_media_file_type === "Image" ? (
              <div className="l2photo">
                <img
                  src={location.state.media.finalfile.txt_media_streaming_link}
                  alt="img or video"
                  width="100%"
                  height="100%"
                />
              </div>
            ) : location.state?.media.finalfile.txt_media_file_type ===
              "Video" ? (
              <div className="l2photo">
                <ReactPlayer
                  url={location.state.media.finalfile.txt_media_streaming_link}
                  loop={true}
                  height="100%"
                  width="100%"
                  playing={true}
                  playsInline
                  controls
                />
              </div>
            ) : location.state?.media.finalfile?.txt_media_file_type ===
              "Widget" ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: location.state?.finalfile?.txt_media_streaming_link,
                }}
                style={{ height: "100%", width: "100%" }}
              />
            ) : null}
            <div className="footer urdu-text">
              <Marquee
                style={{ fontSize: "28px", height: "100%", color: "white" }}
                direction="left"
                gradient={false}
              >
                {typeof location.state?.footer === "string" ? (
                  <b>{location.state?.footer}</b>
                ) : (
                  location.state?.footer?.map((footerdes, index) => (
                    <div key={index} className="mr-5">
                      {/* {footerdes.txt_footer_description} */}
                      <b>{footerdes.txt_news_title}</b>
                    </div>
                  ))
                )}
              </Marquee>
            </div>
          </div>
        </div>
        <div className="standouter">
          <div className="stand"></div>
        </div>
      </div>
    </div>
  );
};

export default TemplateTwo;

// {typeof location.state?.footer === 'string' ?  <b>{location.state?.footer}<b>  :
//                 {location.state?.footer?.map((footerdes, index) => (<div key={index} className="mr-5">
//     <b>{footerdes.txt_news_title}</b>
//   </div>
// ))}}
